export const useUtilities = () => {
  const getMetaSnippet = (content) => {
    if (!content) return "";
    const snippet = content.substring(0, 150);
    return snippet.slice(0, snippet.lastIndexOf(" ")) + "...";
  };

  return { getMetaSnippet };
};
